import { useIntl } from 'react-intl'

import Stack from 'app/components/base/Stack'
import ShareButton from 'app/components/buttons/ShareButton'
import CreatedAt from 'app/features/Blog/components/CreatedAt'
import { convertToBlogOptionModel } from 'app/utils/helpers/blog.helpers'

import ArticleAssociatedTags from './ArticleAssociatedTags'

interface ArticleFooterProps {
  createdAt: string | number | Date
  shareLink: string
  media: string[]
  tags: BlogTagModel[]
}

const ArticleFooter: RFC<ArticleFooterProps> = ({
  createdAt,
  shareLink,
  media,
  tags
}) => {
  const intl = useIntl()
  const hasArticleTags = tags.length > 0
  const articleTagList = convertToBlogOptionModel(tags)

  const shareButtonTitle = intl.formatMessage({
    defaultMessage: 'Share this article'
  })

  return (
    <>
      <Stack
        sx={{
          flexDirection: 'row',
          alignItems: 'flex-start',
          pt: 2,
          borderTopWidth: 1,
          borderTopColor: 'border.main',
          position: 'relative',
          borderTopStyle: 'solid'
        }}
      >
        <CreatedAt date={createdAt} />

        {hasArticleTags && (
          <ArticleAssociatedTags
            tags={articleTagList}
            sx={{
              display: { xs: 'none', md: 'flex' },
              ml: 2,
              alignItems: 'center',
              maxWidth: { md: '70%', lg: '75%' }
            }}
          />
        )}

        <ShareButton
          url={shareLink}
          media={media}
          listingTitle={shareButtonTitle}
          sx={{
            mt: 0,
            ml: 'auto',
            top: -8,
            position: { md: 'relative' }
          }}
        />
      </Stack>

      <ArticleAssociatedTags
        tags={articleTagList}
        sx={{
          mt: 1,
          display: { xs: 'flex', md: 'none' },
          flexWrap: 'wrap',
          rowGap: 1
        }}
      />
    </>
  )
}

export default ArticleFooter
